"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.uuid = exports.ukMobileNumber = exports.ukLandlineNumber = exports.supporterId = exports.requiredValue = exports.required = exports.postcode = exports.phoneNumber = exports.notAcademicEmail = exports.min = exports.fixedLength = exports.failValue = exports.email = exports.donorId = exports.differentTo = exports.date = exports.cvv = exports.currency = exports.card = exports.babyDueDate = exports.ageRange = exports.age = void 0;

var _moment = _interopRequireDefault(require("moment"));

var _lodash = _interopRequireDefault(require("lodash"));

var _gaPushToDataLayer = _interopRequireDefault(require("../../../utils/gaPushToDataLayer"));

var _types = require("../../../types");

var _flowRuntime = _interopRequireDefault(require("flow-runtime"));

var FailValue = _flowRuntime["default"].tdz(function () {
  return _types.FailValue;
});

var RequiredValue = _flowRuntime["default"].tdz(function () {
  return _types.RequiredValue;
});

var Validator = _flowRuntime["default"].tdz(function () {
  return _types.Validator;
});

var validateAge = function validateAge(value, minimumAge, maximumAge) {
  var dob = (0, _moment["default"])(value);
  var today = (0, _moment["default"])();

  var difference = _moment["default"].duration(today.diff(dob));

  var age = Math.floor(difference.asYears());

  if ((!minimumAge || age >= minimumAge) && (!maximumAge || age <= maximumAge)) {
    return true;
  }

  return false;
};

var ageRange = function ageRange(minimumAge, maximumAge, message) {
  return function (value) {
    if (!value || validateAge(value, minimumAge, maximumAge)) {
      return undefined;
    }

    (0, _gaPushToDataLayer["default"])(window.location.pathname, "Age validation failure");
    return message || "Invalid age - you must be between ".concat(minimumAge || 'unknown', " and ").concat(maximumAge || 'unknown', " to join the register");
  };
}; // http://www.regular-expressions.info/creditcard.html


exports.ageRange = ageRange;

var card = function card(value) {
  return !value || /^(?:4[0-9]{12}(?:[0-9]{3})?|(?:5[1-5][0-9]{2}|222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)[0-9]{12}| 3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|6(?:011|5[0-9]{2})[0-9]{12}|(?:2131|1800|35\d{3})\d{11})$/i.test(value) ? undefined : 'Please enter a valid card number, with no spaces or dashes';
}; // https://stackoverflow.com/questions/308122/simple-regular-expression-for-a-decimal-with-a-precision-of-2


exports.card = card;

var currency = function currency(value) {
  return !value || /^[0-9]+(\.[0-9][0-9]?)?$/i.test(value) ? undefined : 'Please enter a valid amount in pounds';
};

exports.currency = currency;

var cvv = function cvv(value) {
  return !value || /^\d+$/i.test(value) && value.length === 3 ? undefined : 'Please enter 3 digits';
};

exports.cvv = cvv;

var date = function date(value) {
  return !value || (0, _moment["default"])(value, 'YYYY-MM-DD', true).isValid() ? undefined : "Please enter a valid date, for example 01-02-1999";
};

exports.date = date;

var babyDueDate = function babyDueDate(value) {
  return !value || (0, _moment["default"])(value, 'YYYY-MM-DD').isBefore((0, _moment["default"])().add(40, 'weeks')) && (0, _moment["default"])(value, 'YYYY-MM-DD').isAfter((0, _moment["default"])()) ? undefined : "Please enter a valid date between now and 40 weeks";
};

exports.babyDueDate = babyDueDate;

var age = function age(value) {
  return !value || (0, _moment["default"])(value, 'YYYY-MM-DD').isAfter((0, _moment["default"])().subtract(100, 'years')) && (0, _moment["default"])(value, 'YYYY-MM-DD').isBefore((0, _moment["default"])()) ? undefined : "Please enter a valid date of birth, for example 01-04-1987";
};

exports.age = age;

var differentTo = function differentTo(item) {
  return function (value, allValues) {
    return !value || value !== _lodash["default"].get(allValues, item) ? undefined : "This value must be different to ".concat(_lodash["default"].get(allValues, item));
  };
}; // http://emailregex.com/


exports.differentTo = differentTo;

var email = function email(value) {
  return !value || /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i.test(value) ? undefined : 'Please enter a valid email address';
};

exports.email = email;

var notAcademicEmail = function notAcademicEmail(value) {
  return !value || !/ac\.uk/.test(value) ? undefined : 'Please use a different email address, or give us a ring on 0207 424 6567 if you have any problems';
};

exports.notAcademicEmail = notAcademicEmail;

var fixedLength = function fixedLength(n) {
  return function (value) {
    return !value || value.length === n ? undefined : "Must be ".concat(n.toString(), " characters");
  };
};

exports.fixedLength = fixedLength;

var min = function min(num) {
  return function (value) {
    return !value || value > num ? undefined : "Must be at least ".concat(num.toString());
  };
};

exports.min = min;

var phoneNumber = function phoneNumber(value) {
  return !value || /^0[^7]\d{8,9}$|^07\d{9}$/i.test(value) ? undefined : 'Please enter a valid UK landline or mobile phone number. For a landline number, this means 10 or 11 numbers, beginning with 0, and the second number cannot be 7. For a mobile number, This means 11 numbers, beginning with 07.';
};

exports.phoneNumber = phoneNumber;

var ukLandlineNumber = function ukLandlineNumber(value) {
  return !value || /^0[^7]\d{8,9}$/i.test(value) ? undefined : 'Please enter a valid UK landline phone number. This means 10 or 11 numbers, beginning with 0, and the second number cannot be 7.';
};

exports.ukLandlineNumber = ukLandlineNumber;

var ukMobileNumber = function ukMobileNumber(value) {
  return !value || /^07\d{9}$/i.test(value) ? undefined : 'Please enter a valid UK mobile phone number. This means 11 numbers, beginning with 07.';
}; // http://stackoverflow.com/questions/164979/uk-postcode-regex-comprehensive#7259020


exports.ukMobileNumber = ukMobileNumber;

var postcode = function postcode(value) {
  return !value || /^(([gG][iI][rR] {0,}0[aA]{2})|((([a-pr-uwyzA-PR-UWYZ][a-hk-yA-HK-Y]?[0-9][0-9]?)|(([a-pr-uwyzA-PR-UWYZ][0-9][a-hjkstuwA-HJKSTUW])|([a-pr-uwyzA-PR-UWYZ][a-hk-yA-HK-Y][0-9][abehmnprv-yABEHMNPRV-Y])))\s{0,1}[0-9][abd-hjlnp-uw-zABD-HJLNP-UW-Z]{2}))$/i.test(value) ? undefined : 'Please enter a valid postcode';
};

exports.postcode = postcode;

var required = function required(value) {
  return value === undefined || value === null || value === '' || value && value.length === 0 ? 'Required' : undefined;
};

exports.required = required;

var failValue = function failValue(fail) {
  return function (value) {
    return value !== fail.value ? undefined : fail.errorMsg;
  };
};

exports.failValue = failValue;

var requiredValue = function requiredValue(requiredObj) {
  return function (value) {
    return value === requiredObj.value ? undefined : requiredObj.errorMsg;
  };
};

exports.requiredValue = requiredValue;

var donorId = function donorId(value) {
  return !value || value >= 1000000 && /^\d{7}$/i.test(value) ? undefined : 'Your Donor number should contain 7 digits with no spaces.';
};

exports.donorId = donorId;

var uuid = function uuid(value) {
  return !value || /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[089ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(value) ? undefined : 'Invalid number - please email <a href="mailto:donor.support@anthonynolan.org">donor.support@anthonynolan.org</a> or call <a href="tel:02074246567">0207 424 6567</a> to update your preferences.';
};

exports.uuid = uuid;

var supporterId = function supporterId(value) {
  return !value || /^CDN-\d{6,7}$|^\d{1,7}$/i.test(value) ? undefined : 'Your Supporter number has not been recognised. If you do not know this number please email <a href="mailto:support@anthonynolan.org">support@anthonynolan.org</a> or call <a href="tel:02074246626">0207 424 6626</a> to update your preferences.';
};

exports.supporterId = supporterId;